import * as basicLightbox from "basiclightbox";

export default function() {
  const CardEmbedButtons = document.querySelectorAll(
    "button.card-embed-basiclightbox-link"
  );
  Array.from(CardEmbedButtons).forEach((elem) => {
    elem.addEventListener("click", (e) => {
      const parent = elem.closest("div.embed-overlay-title-summary");
      if (parent) {
        const iframeElem = parent.querySelector("iframe");
        if (iframeElem) {
          basicLightbox.create(`<div>${iframeElem.outerHTML}</div>`).show();
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/js/partials/card-lightbox.js